<template>
  <div>
    <v-container
      class="pl-sm-12 pr-sm-12"
      fluid
      style="overflow:hidden; position:relative"
    >
      <p class="primary--text display-1 font-weight-bold pt-10 pb-8">
        Mis buceos
      </p>

      <EventBookMap :event-list="eventList"></EventBookMap>

      <!--     <v-subheader class="title mt-4 mb-4">
      <div>
        <span class="body-1">Ordenar por</span>
        <v-btn text>Fecha descendente</v-btn>
      </div>
      </v-subheader>-->

      <div v-if="loading">
        <v-row class="pa-4 pt-0">
          <v-col
            cols="12"
            md="6"
            lg="4"
            v-for="(item, index) of [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]"
            :key="index"
          >
            <v-skeleton-loader
              class="mx-auto flex"
              type="card"
            ></v-skeleton-loader>
          </v-col>
        </v-row>
      </div>
      <div v-else class="pt-12 pb-12">
        <div
          v-if="eventList.length == 0"
          class="pa-4 d-flex flex-column align-center justify-center"
        >
          <v-icon style="font-size: 3rem" color="primary">mdi-view-grid</v-icon>
          <span class="body-1 font-weight-light mt-4 primary--text"
            >Tu lista de buceos está vacía</span
          >
        </div>

        <v-row v-else class="pt-12">
          <v-col
            cols="12"
            md="6"
            v-for="(event, index) of eventList"
            :key="index"
          >
            <EventListItem :event="event"></EventListItem>
          </v-col>
        </v-row>
      </div>
    </v-container>
    <v-img :src="footerImg" full-width height="200" position="0 40%"></v-img>
  </div>
</template>

<script>
import EventBookMap from "./EventBookMap";
import EventListItem from "./EventListItem";
export default {
  components: { EventBookMap, EventListItem },
  data: () => ({
    footerImg: require("@/assets/mis_buceos/cabrilla_1.jpg"),
    loading: true,
    eventList: [],
    sortList: [
      {
        name: "Fecha descendente",
        value: "eventDate DESC"
      },
      {
        name: "Fecha ascendente",
        value: "eventDate DESC"
      }
    ],
    sortSelected: null
  }),
  methods: {
    async getList() {
      try {
        this.loading = true;
        let { data: eventList } = await this.$http.get("event", {
          params: {
            where: {
              recordedBy: this.practitionerLogged.id
            },
            sort: this.sortSelected.value,
            limit: 5000
          }
        });

        this.eventList = eventList;
      } catch (err) {
        console.log(err);
      }
      this.loading = false;
    }
  },
  computed: {
    practitionerLogged() {
      return this.$store.getters["authPractitioner/getPractitioner"];
    }
  },
  async mounted() {
    this.sortSelected = this.sortList[0];
    this.getList();
  }
};
</script>

<style></style>
